import { PrimeReactPTOptions } from "primereact/api";
import { InputTextareaPassThroughMethodOptions } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";

import { focusHoverField, invalidField, placeholder } from "./common";

export const inputtextarea: PrimeReactPTOptions["inputtextarea"] = {
  root: ({ props, context }: InputTextareaPassThroughMethodOptions) => ({
    className: classNames(
      "text-urbe-text border border-urbe-border bg-white",
      "dark:text-white/80 dark:bg-gray-900 dark:border-blue-900/40",
      "rounded",
      "outline-rdc-primary outline-offset-0 p-2",
      placeholder,
      focusHoverField,
      {
        "opacity-60 select-none pointer-events-none cursor-default": context.disabled,
        "bg-urbe-primaryLight text-sm": props.variant === "filled",
        [invalidField]: props.invalid,
      },
    ),
  }),
};
